











import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Technologies',
  props: {
    name: { type: String as () => string, required: true },
  },
  setup() {
    const technologies = ['Vue.js', 'React', 'React Native', 'JS', 'TS']

    return { technologies }
  },
})
